module.exports = __webpack_public_path__ + "static/salonslider-07-min-f6ec85ba2920bcbd7144cdc01b371ef0.jpg";